import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import { goBack, push } from 'react-router-redux';
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Label,
  Menu,
  Progress,
} from 'semantic-ui-react';
import clone from 'clone';
import _ from 'lodash';
import { Link } from 'react-router';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import IncomeForm from '../CreditCheck/NewUpdateIncomeForm';
import UploadForm from '../CreditCheck/UploadForm';
import LoanInfo from '../CreditCheck/UpdateLoanInfo';


export default class NewEditIncome extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    routeParams: PropTypes.shape({
      id: PropTypes.string,
      customerID: PropTypes.string,
      incomeID: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
      hash: PropTypes.string,
    }),
  }
  constructor(props) {
    super(props);
    this.state = {
      booking: null,
      customerID: '',
      data: null,
      errMessages: [],
      income: null,
      loading: true,
      oriIncome: null,
      pathCheck: false,
      token: null,
      incomeToken: null,
      documentToken: null,
      changedForm: false,
      employedForm: null,
      selfEmployedForm: null,
      nextStep: false,
      creditCheckReportData: [],
    };
    this.validation = {};
  }
  componentDidMount() {
    this.handlePathCheck();
  }
  async getDocumentToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.state.customerID}/documents/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
    .catch((err) => {
      store.dispatch(flashErrorMessage(err));
    })
    .then((res) => {
      const documentToken = res.headers.get('X-Csrf-Token');
      this.setState({
        documentToken,
      }, () => {
        if (callback) {
          callback();
        }
      });
    });
  }
  getIncomeToken(callback) {
    const { store } = this.context;
    store.dispatch(fetchM(`/customers/${this.state.customerID}/income/`, {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }))
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      })
      .then((res) => {
        const incomeToken = res.headers.get('X-Csrf-Token');
        this.setState({
          incomeToken,
        }, () => {
          if (callback) {
            callback();
          }
        });
      });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  checkStringify = (source, target) => JSON.stringify(source) === JSON.stringify(target)
  checkUpdateDisabled = () => {
    const { income } = this.state;
    const hasIncome = income && ((income.netIncome !== '' || income.netIncome > 0) ||
    (!income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0)));
    if (!hasIncome) {
      return true;
    }
    return false;
  }
  fetchBooking = async () => {
    await this.setLoading(true);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/bookings/${this.props.routeParams.id}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    const json = await res.json();
    if (json) {
      const newBooking = Object.assign({}, json || {});
      this.setState({ booking: newBooking });
    }
    await this.setLoading(false);
  }
  async fetchCustomer() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.state.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newData = Object.assign({}, json || {});
      this.setState({ data: newData });
    }
    await this.setLoading(false);
  }
  async fetchCustomerCreditReport() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.customerID}/credit_reports/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const json = await res.json();
    if (json) {
      const newCreditCheckReport = Object.assign({}, json[0] || {});
      this.setState({ creditCheckReportData: newCreditCheckReport });
    }
    await this.setLoading(false);
  }
  async fetchIncome() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${this.state.customerID}/income/${this.props.routeParams.incomeID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const income = await res.json();
      // handle token.. etc
      await this.setComponentState({
        token,
        income,
        oriIncome: clone(income),
      });
    }
    await this.setLoading(false);
  }
  async updateIncome(income) {
    const { store } = this.context;
    const { customerID, pathCheck, token } = this.state;
    let res;
    await this.setLoading(true);
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/customers/${customerID}/income/${income.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': token,
        },
        body: JSON.stringify(income),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    await this.setLoading(false);
    if (pathCheck) {
      store.dispatch(push(`/bookings/${this.props.routeParams.id}/`));
    } else {
      store.dispatch(push(`/customers/${this.state.customerID}/`));
    }
    store.dispatch(flashSuccessMessage({ header: 'Update Successs', message: 'Customer income has been successfully updated' }));
  }

  async uploadDocument(body, key = 'employedForm') {
    await this.setLoading(true);
    const { store } = this.context;
    const { income } = this.state;
    let res;
    await this.setLoading(true);
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.customerID}/income/${income.id}/documents/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.state.documentToken,
        },
        body,
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const json = await res.json();
    if (json) {
      const newIncome = Object.assign({}, income || {});
      newIncome.id = json.id;
      if (json.epfStatementDocumentID !== '') {
        newIncome.epfStatementDocumentID = json.epfStatementDocumentID;
        newIncome.epfStatementDocument = json.epfStatementDocument;
      }
      if (json.bankStatementDocumentID !== '') {
        newIncome.bankStatementDocumentID = json.bankStatementDocumentID;
        newIncome.bankStatementDocument = json.bankStatementDocument;
      }
      if (json.payslipDocumentID !== '') {
        newIncome.payslipDocumentID = json.payslipDocumentID;
        newIncome.payslipDocument = json.payslipDocument;
      }
      if (json.bFormDocumentID !== '') {
        newIncome.bFormDocumentID = json.bFormDocumentID;
        newIncome.bFormDocument = json.bFormDocument;
      }
      this.setState({ income: newIncome, changedForm: false }, () => {
        this.getIncomeToken(() => {
          this.handleSubmitIncome();
        });
      });
    }
    await this.setLoading(false);
    if (key === 'employed') {
      await this.employedFormUpload.resetFiles();
    }
    if (key === 'selfEmployed') {
      await this.bFormUpload.resetFiles();
    }
  }
  handleSubmitIncome = async () => {
    const { store } = this.context;
    const { creditCheckReportData, income } = this.state;
    if (income.isEmployed) {
      income.bYearlyIncome = 0;
      income.otherYearlyIncome = 0;
      income.bFormDocumentID = '';
      income.bFormDocument = null;
    }
    if (!income.isEmployed) {
      income.basicIncome = 0;
      income.fixAllowance = 0;
      income.grossIncome = 0;
      income.deduction = 0;
      income.epfStatementDocumentID = '';
      income.epfStatementDocument = null;
      income.payslipDocumentID = '';
      income.payslipDocument = null;
      income.bankStatementDocumentID = '';
      income.bankStatementDocument = null;
    }
    if (income.netIncome <= 0) {
      await store.dispatch(flashErrorMessage({ header: 'Net Income must be more than 0' }));
      return;
    }
    income.currentLoanAmount = creditCheckReportData.currentLoanAmount;
    await this.setState({ income }, () => this.updateIncome(income));
  }
  handleCancel = (e) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(goBack());
  }
  handleChangeTab = (isEmployed = false) => {
    const { income } = this.state;
    const newIncome = Object.assign({}, income);
    newIncome.isEmployed = isEmployed;
    if (newIncome.isEmployed) {
      const grossIncome = _.toNumber(_.toNumber(newIncome.basicIncome) + _.toNumber(newIncome.fixAllowance)).toFixed(2);
      newIncome.grossIncome = _.toNumber(grossIncome);
      const netIncome = _.toNumber(_.toNumber(newIncome.grossIncome) - _.toNumber(newIncome.deduction)).toFixed(2);
      newIncome.netIncome = _.toNumber(netIncome);
    }
    if (!newIncome.isEmployed) {
      const totalYearlyIncome = _.toNumber(newIncome.bYearlyIncome) + _.toNumber(newIncome.otherYearlyIncome);
      const totalMonthlyIncome = _.toNumber(totalYearlyIncome) / 12;
      const roughIncome = _.toNumber(totalMonthlyIncome).toFixed(2);
      newIncome.netIncome = _.toNumber(roughIncome);
    }
    this.handleIncomeChange(newIncome);
  }
  handleCreateFormData = (type) => {
    const { income } = this.state;
    let formData = null;
    if (type === 'employed') {
      if (income.epfStatementDocument || income.payslipDocument || income.bankStatementDocument) {
        formData = this.employedFormUpload.getFormData();

        if (income.epfStatementDocument) {
          formData.append('files_0', income.epfStatementDocument.file);
          formData.append('tags_0', income.epfStatementDocument.tags);
          formData.append('names_0', income.epfStatementDocument.name);
          formData.append('degrees_0', income.epfStatementDocument.degree);
        }
        if (income.payslipDocument) {
          formData.append('files_1', income.payslipDocument.file);
          formData.append('tags_1', income.payslipDocument.tags);
          formData.append('names_1', income.payslipDocument.name);
          formData.append('degrees_1', income.payslipDocument.degree);
        }
        if (income.bankStatementDocument) {
          formData.append('files_2', income.bankStatementDocument.file);
          formData.append('tags_2', income.bankStatementDocument.tags);
          formData.append('names_2', income.bankStatementDocument.name);
          formData.append('degrees_2', income.bankStatementDocument.degree);
        }
      }
    } else if (type === 'selfEmployed') {
      if (income.bFormDocument) {
        formData = this.bFormUpload.getFormData();
        formData.append('files_0', income.bFormDocument.file);
        formData.append('tags_0', income.bFormDocument.tags);
        formData.append('names_0', income.bFormDocument.name);
        formData.append('degrees_0', income.bFormDocument.degree);
      }
    }
    return formData;
  }
  handleGetForm = (form, formName = 'epfStatementDocument') => {
    const { income } = this.state;
    income[formName] = form;
    this.setState({ income, changedForm: true });
  }
  handleIncomeChange = (income) => {
    this.setState({ income });
  }
  handleLoanChange = (creditCheckReportData) => {
    this.setState({ creditCheckReportData });
  }
  handlePathCheck() {
    if (this.props.location.pathname.includes('/bookings/')) {
      this.setState({ customerID: this.props.routeParams.customerID, pathCheck: true }, () => {
        this.fetchBooking();
        this.fetchCustomer();
        this.fetchCustomerCreditReport();
        this.fetchIncome();
      });
    } else {
      this.setState({ customerID: this.props.routeParams.id }, () => {
        this.fetchCustomer();
        this.fetchCustomerCreditReport();
        this.fetchIncome();
      });
    }
  }
  handleClickNext = async () => {
    const { changedForm, income } = this.state;
    if (income && ((income.netIncome !== '' || income.netIncome > 0) ||
    (!income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0)))) {
      if (changedForm) {
        if (income.isEmployed) {
          const newEmployedForm = this.handleCreateFormData('employed');
          this.setState({ employedForm: newEmployedForm });
        } else {
          const newSelfEmployedForm = this.handleCreateFormData('selfEmployed');
          this.setState({ selfEmployedForm: newSelfEmployedForm });
        }
      }
      await this.setState({ nextStep: true });
    }
  }
  handlePreviousStep = (e) => {
    e.preventDefault();
    this.setState({ nextStep: false });
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  handleUpdate = async () => {
    this.handleUpdateIncome();
  }
  handleUpdateIncome = () => {
    const { changedForm, income, employedForm, selfEmployedForm } = this.state;
    if (income && ((income.netIncome !== '' || income.netIncome > 0) ||
    (!income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0)))) {
      if (changedForm) {
        this.getDocumentToken(() => {
          if (income.isEmployed) {
            if (employedForm !== null) {
              this.uploadDocument(employedForm, 'employedForm');
            } else {
              this.handleSubmitIncome();
            }
          } else {
            if (selfEmployedForm !== null) {
              this.uploadDocument(selfEmployedForm, 'selfEmployed');
            } else {
              this.handleSubmitIncome();
            }
          }
        });
      } else {
        this.getIncomeToken(() => {
          this.handleSubmitIncome();
        });
      }
    }
  }
  tabs = [
    { name: 'isEmployed', text: 'Employed', isEmployed: true },
    { name: 'SelfEmployed', text: 'Self Employed', isEmployed: false },
  ];
  checkNextDisabled = () => {
    const { income, nextStep } = this.state;
    if (!nextStep) {
      if (income.netIncome <= 0) {
        return true;
      }
    }
    return false;
  }
  renderStepContent() {
    const { data, customerID, income, nextStep } = this.state;
    if (nextStep) {
      return (
        <Grid centered columns={12}>
          <Grid.Row>
            <Grid.Column computer={8} tablet={10} mobile={16}>
              <LoanInfo
                loading={this.state.loading}
                data={data}
                onChange={this.handleLoanChange}
                bookingCustomerData={this.state.booking}
                creditCheckReportData={this.state.creditCheckReportData}
                pathCheck={this.state.pathCheck}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return (
      <Grid.Row>
        <Grid.Column>
          <Grid centered>
            <Grid.Row>
              <Grid.Column computer={8} tablet={10} mobile={16}>
                <Header as="h2" content="I am" textAlign="left" />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Grid columns={1} textAlign="center" stackable doubling>
                  <Grid.Row>
                    <Grid.Column computer={8} tablet={10} mobile={16}>
                      <div className="menuTab">
                        <Menu fluid widths={2}>
                          {
                          this.tabs.map((tab, idx) => (
                            <Menu.Item
                              key={idx}
                              name={tab.name}
                              onClick={() => this.handleChangeTab(tab.isEmployed)}
                              active={income.isEmployed === tab.isEmployed}
                            >
                              {tab.text}
                            </Menu.Item>
                          ))
                        }
                        </Menu>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <IncomeForm
                  loading={this.state.loading}
                  customerID={customerID}
                  income={income}
                  data={data}
                  onChange={this.handleIncomeChange}
                />
                <Grid centered>
                  <Grid.Row>
                    {
                      income.isEmployed ? (
                        <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                          <Header
                            as="h3"
                            content="Upload Documents"
                            textAlign="left"
                            style={{ marginTop: '2em', marginBottom: '0.5em' }}
                          />
                          <UploadForm
                            title="FinancialForm"
                            labelContent="Latest EPF Statement"
                            ref={(ref) => { this.employedFormUpload = ref; }}
                            loading={this.state.loading}
                            tags={['Financial EPF']}
                            picture={data.epfStatementDocumentID && data.epfStatementDocumentID.length > 0 ? data.epfStatementDocument : null}
                            onChange={form => this.handleGetForm(form, 'epfStatementDocument')}
                          />
                          <UploadForm
                            title="FinancialForm"
                            labelContent="Latest 3 months payslip"
                            ref={(ref) => { this.employedFormUpload = ref; }}
                            loading={this.state.loading}
                            tags={['Financial Payslip']}
                            picture={data.payslipDocumentID && data.payslipDocumentID.length > 0 ? data.payslipDocument : null}
                            onChange={form => this.handleGetForm(form, 'payslipDocument')}
                            style={{ height: '4rem !important' }}
                          />
                          <UploadForm
                            title="FinancialForm"
                            labelContent="Latest 3 months bank statement"
                            ref={(ref) => { this.employedFormUpload = ref; }}
                            loading={this.state.loading}
                            tags={['Financial BankStatement']}
                            picture={data.bankStatementDocumentID && data.bankStatementDocumentID.length > 0 ? data.bankStatementDocument : null}
                            onChange={form => this.handleGetForm(form, 'bankStatementDocument')}
                          />
                        </Grid.Column>
                      ) : null
                    }
                    {
                      !income.isEmployed ? (
                        <Grid.Column computer={7} tablet={9} mobile={16} textAlign="right">
                          <Header
                            as="h3"
                            content="Upload Documents"
                            textAlign="left"
                            style={{ marginTop: '2em', marginBottom: '0.5em' }}
                          />
                          <UploadForm
                            title="FinancialForm"
                            labelContent="B Form"
                            ref={(ref) => { this.bFormUpload = ref; }}
                            loading={this.state.loading}
                            tags={['Financial BForm']}
                            picture={data.bFormDocumentID && data.bFormDocumentID.length > 0 ? data.bFormDocument : null}
                            onChange={form => this.handleGetForm(form, 'bFormDocument')}
                          />
                        </Grid.Column>
                      ) : null
                    }
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }
  renderStep() {
    const { nextStep } = this.state;
    return (
      <Grid centered>
        <Grid.Row style={{ paddingBottom: '0px' }}>
          <Grid.Column computer={4} tablet={5} mobile={8}>
            <Header textAlign="left">
              { !nextStep ? 'Financial Info' : 'Loan Info' }
            </Header>
          </Grid.Column>
          <Grid.Column computer={4} tablet={5} mobile={8}>
            <p style={{ textAlign: 'right' }}>
              {!nextStep ? '4 of 5' : '5 of 5'}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column computer={8} tablet={10} mobile={16}>
            {
              !nextStep ? (
                <div className="progressBar">
                  <Progress
                    percent={80}
                    size="tiny"
                  />
                </div>
              ) : (
                <div className="progressBar">
                  <Progress
                    percent={100}
                    size="tiny"
                  />
                </div>
              )
            }
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {this.renderStepContent()}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div className="buttonBorder">
              <Container style={{ borderTop: '1px solid rgb(217, 218, 220)', padding: '0.5rem', borderRadius: '0.25rem' }} />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ padding: 0 }}>
          <Grid.Column computer={8} tablet={10} mobile={16}>
            <div className="nextButton">
              <Button
                fluid
                onClick={!nextStep ? this.handleClickNext : this.handleUpdate}
                disabled={this.state.loading || this.checkNextDisabled()}
              >
                {
                  !nextStep ? 'Next' : 'Update'
                }
              </Button>
            </div>
            {
              nextStep ? (
                <div className="backButton">
                  <Button
                    onClick={this.handlePreviousStep}
                    disabled={this.state.loading}
                    content="< Back"
                  />
                </div>
              ) : (
                <div className="backButton">
                  <Button
                    floated="left"
                    onClick={this.handleCancel}
                    disabled={this.state.loading}
                    content="< Cancel"
                  />
                </div>
              )
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    const { data, booking, income, pathCheck } = this.state;
    return (
      data !== null && income !== null ? (
        <div>
          {booking && pathCheck &&
            <Header as="h4" textAlign="center">
              Booking for <br className="large-hide small-hide tablet-hide" /><Link to={`/projects/${booking.project && booking.project.id}/units/${booking.projectUnit && booking.projectUnit.id}/`}>{booking.projectUnit && booking.projectUnit.reference}</Link>, {booking.project && booking.project.name} {booking.projectUnit && booking.projectUnit.isBumi && <Label size="mini">Bumi</Label>}
            </Header>
          }
          <Divider
            horizontal
            style={{ color: 'rgba(112, 112, 112, 1)' }}
          >
            {pathCheck ? 'Customer Assessment' : 'Credit Check'}
          </Divider>
          <Container style={{ border: '1px solid rgb(217, 218, 220)', padding: '3rem', borderRadius: '0.25rem' }}>
            {this.renderStep()}
          </Container>
        </div>
      ) : null
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Customers/NewEditIncome.jsx